<template>
  <PremiumModalForm
    :value="value"
    @input="$emit('input', $event)"
    title="Change Password"
    submitText="Update Password"
    :loading="loading"
    @submit="changePassword"
    maxWidth="450"
  >
    <v-form @submit.prevent="changePassword">
      <PremiumInput
        label="Old Password"
        v-model="user.oldPassword"
        name="Old Password"
        placeholder="Enter current password"
        :type="showOldPassword ? 'text' : 'password'"
        icon="mdi-lock-outline"
        v-validate="'required'"
        :error="errors.first('Old Password') || serverSideErrors.oldPassword"
      >
        <template v-slot:append>
          <v-icon size="18" @click="showOldPassword = !showOldPassword" color="#64748b">
            {{ showOldPassword ? 'mdi-eye' : 'mdi-eye-off' }}
          </v-icon>
        </template>
      </PremiumInput>

      <PremiumInput
        label="New Password"
        v-model="user.password"
        name="password"
        placeholder="Enter new password"
        :type="showPassword ? 'text' : 'password'"
        icon="mdi-lock-reset"
        v-validate="'required'"
        :error="errors.first('password') || serverSideErrors.password"
      >
        <template v-slot:append>
          <v-icon size="18" @click="showPassword = !showPassword" color="#64748b">
            {{ showPassword ? 'mdi-eye' : 'mdi-eye-off' }}
          </v-icon>
        </template>
      </PremiumInput>

      <PremiumInput
        label="Confirm New Password"
        v-model="user.password_confirmation"
        name="Confirm Password"
        placeholder="Re-enter new password"
        :type="showConfirmPassword ? 'text' : 'password'"
        icon="mdi-lock-check-outline"
        v-validate="'required'"
        :error="errors.first('Confirm Password') || serverSideErrors.password_confirmation"
      >
        <template v-slot:append>
          <v-icon size="18" @click="showConfirmPassword = !showConfirmPassword" color="#64748b">
            {{ showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off' }}
          </v-icon>
        </template>
      </PremiumInput>
    </v-form>
  </PremiumModalForm>
</template>

<script>
import { mapMutations } from 'vuex';
import PremiumModalForm from '../../common/PremiumModalForm.vue';
import PremiumInput from '../../common/PremiumInput.vue';

export default {
  name: 'ChangePasswordModal',
  components: { PremiumModalForm, PremiumInput },
  props: {
    value: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      showOldPassword: false,
      showPassword: false,
      showConfirmPassword: false,
      user: {
        oldPassword: '',
        password: '',
        password_confirmation: '',
      },
      serverSideErrors: {},
    };
  },
  methods: {
    ...mapMutations('alert',['setAlert']),
    
    changePassword() {
      this.$validator.validateAll().then((result) => {
        if (!result) return;
        
        this.loading = true;
        this.$axios.post('/superadmin/changePassword', this.user)
        .then(response => {
          this.loading = false;
          this.serverSideErrors = {};
          const data = response.data;

          if (data.status) {
            data.user.role = 'superadmin';
            localStorage.setItem('user', JSON.stringify(data.user));

            this.setAlert({ showAlert: true, message: data.message, variant: 'green accent-4', timeout: 3000 });
            this.$emit('input', false); // Close modal on success
          } else {
            if (data.errors) {
              data.errors.forEach(err => { this.serverSideErrors[err.field] = err.message; });
            } else {
              this.setAlert({ showAlert: true, message: data.message, variant: 'red accent-3', timeout: 3000 });
            }
          }
        }).catch(() => { this.loading = false; });
      });
    }
  }
};
</script>

<style scoped>
.ism-field-group { display: flex; flex-direction: column; gap: 6px; }
.ism-field-label {
  font-size: 11.5px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.05em; color: var(--text-secondary, #64748b);
}
</style>